import PropTypes from 'prop-types';
import requiredIf from 'react-required-if';

const translationShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  values: PropTypes.object,
});

export const navigationPointer = {
  text: requiredIf(PropTypes.string, (props) => !props.translation),
  translation: requiredIf(translationShape, (props) => !props.text),
  href: PropTypes.string.isRequired,
};

export const contextShape = PropTypes.shape({
  previous: PropTypes.shape(navigationPointer),
  next: PropTypes.shape(navigationPointer),
});
